import { normalizeBsBonusDetails } from '../normalizeBsBonusDetails';

export const normalizeAllTypesBonuses = ({ bonuses, currency }) =>
  bonuses.map(({ type, data }) =>
    type.startsWith('bs')
      ? normalizeBsBonusDetails({ ...data, fullBonusType: type }, currency)
      : {
          ...data,
          fullBonusType: type
        }
  );
